import { render } from "./wAlert.vue?vue&type=template&id=5d18eff4&ts=true"
import script from "./wAlert.vue?vue&type=script&lang=ts"
export * from "./wAlert.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__